/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_ShotInputs */

const en_pc_cmp_shot = /** @type {(inputs: Pc_Cmp_ShotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`comments, stamps and the Layers panel on a review page`)
};

const zh_pc_cmp_shot = /** @type {(inputs: Pc_Cmp_ShotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`审阅页面上的批注、印章与图层面板`)
};

/**
* | output |
* | --- |
* | "comments, stamps and the Layers panel on a review page" |
*
* @param {Pc_Cmp_ShotInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_shot = /** @type {((inputs?: Pc_Cmp_ShotInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_ShotInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_shot(inputs)
	return zh_pc_cmp_shot(inputs)
});
export { pc_cmp_shot as "pc.cmp.shot" }